import {EntityByKey, ResponseError} from "../../../models"
import {RecordStatusEnum} from "../../doctor-stats/models"

export type RecordsStateType = {
    current: Record | null
    currentSignals: EntityByKey<Signal> | null
    fetching: boolean
    fetchingSignals: boolean
    receiveNext: boolean
    receiveNextError: ResponseError | null
    approveDialogActive: boolean
    currentApproving: boolean
    updatingConclusion: boolean
    isConclusionEditing: boolean
    isParameterEditing: boolean
    updatingParameters: boolean
    updatedParameters: boolean
    parametersError: string | null
    isInterpretationUpdating: boolean
    isInterpretationUpdated: boolean
    pdf: any
    fetchingPDF: boolean
    recordApproved: boolean
    recordConflict: boolean,
    //toggleGraph: boolean,
}

export type Record = {
    ecgId: string
    teleRecordId: string
    status: RecordStatusEnum
    intervalsAnalysed: boolean
    metaData: {
        dateTime: string
        duration: string
        deviceId: string
        resolution: number | null
        sampleRate: number | null
        sex: string | null
        age: number | null
        reason: string
        antihypertensive: boolean
        diabetes: boolean
        dyslipidemia: boolean
        pacemaker: boolean
        note: string
    }
    patientInfo: {
        firstName: string | null
        surName: string | null
        id: string | null
        sex: string | null
        age: number | string | null
        birthDay: string | null
        averageHr: number | null
        minHr: number | null
        maxHr: number | null
    }
    commonParameters?: {
        qrsAxis?: number
        rrInterval?: number
        prInterval?: number
        qtInterval?: number
        qtcInterval?: number
        qtcfInterval?: number
        heartRate?: number
        qrsDuration?: number
        pAxis?: number
        tAxis?: number
        pDuration?: number
        tDuration?: number
    }
    leadsData: Array<LeadData>
    conclusion: string
    interpretation: string
    fileName: string
    recordType: string
}

export type LeadData = {
    lead: string
    stAmp: number
    pamp: number
    qamp: number
    ramp: number
    samp: number
    tamp: number
}

export type Signal = {
    lead: string
    units: string
    sampleRate: number
    data: Array<number>
}

export enum LeadEnum {
    I = "I",
    II = "II",
    III = "III",
    AVR = "AVR",
    AVL = "AVL",
    AVF = "AVF",
    V1 = "V1",
    V2 = "V2",
    V3 = "V3",
    V4 = "V4",
    V5 = "V5",
    V6 = "V6",
}

export enum RecordTypeEnum {
    HOLTER = "HOLTER",
    ECG = "ECG",
}
